export const redirectPaths = {
  HOME_ROUTE: '/',
  REQUEST_RECIEVED_PAGE: '/request-received-page'
};
